"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FloatingRefinery = void 0;
const Card_1 = require("../Card");
const CardName_1 = require("../../CardName");
const CardType_1 = require("../CardType");
const CardRenderer_1 = require("../render/CardRenderer");
const Tags_1 = require("../Tags");
const ResourceType_1 = require("../../ResourceType");
const Resources_1 = require("../../Resources");
const OrOptions_1 = require("../../inputs/OrOptions");
const SelectOption_1 = require("../../inputs/SelectOption");
const LogHelper_1 = require("../../LogHelper");
const SelectCard_1 = require("../../inputs/SelectCard");
class FloatingRefinery extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.ACTIVE,
            name: CardName_1.CardName.FLOATING_REFINERY,
            tags: [Tags_1.Tags.VENUS],
            cost: 7,
            resourceType: ResourceType_1.ResourceType.FLOATER,
            metadata: {
                cardNumber: 'P73',
                description: 'Add 1 floater here for each Venus tag you have, including this.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.action(undefined, (eb) => {
                        eb.empty().startAction.floaters(1).or();
                    });
                    b.br;
                    b.action('Add 1 floater here, or remove 2 floaters from ANY CARD to gain 1 titanium and 2 M€.', (eb) => {
                        eb.floaters(2).asterix().startAction.titanium(1).megacredits(2);
                    });
                    b.br.br;
                    b.floaters(1).slash().venus(1).played;
                }),
            },
        });
        this.resourceCount = 0;
    }
    play(player) {
        player.addResourceTo(this, { qty: player.getTagCount(Tags_1.Tags.VENUS) + 1, log: true });
        return undefined;
    }
    canAct() {
        return true;
    }
    action(player) {
        const removeFloatersTargets = player.getCardsWithResources(ResourceType_1.ResourceType.FLOATER).filter((c) => c.resourceCount > 1);
        if (removeFloatersTargets.length === 0) {
            player.addResourceTo(this, { log: true });
            return undefined;
        }
        const orOptions = new OrOptions_1.OrOptions();
        if (removeFloatersTargets.length === 1) {
            orOptions.options.push(new SelectOption_1.SelectOption(`Remove 2 floaters from ${removeFloatersTargets[0].name} to gain 1 titanium and 2 M€`, 'Remove floaters', () => {
                this.applyEffect(player, removeFloatersTargets[0]);
                return undefined;
            }));
        }
        else {
            orOptions.options.push(new SelectOption_1.SelectOption('Remove 2 floaters from a card to gain 1 titanium and 2 M€', 'Remove floaters', () => {
                return new SelectCard_1.SelectCard('Select card to remove 2 floaters', 'Select', removeFloatersTargets, (foundCards) => {
                    this.applyEffect(player, foundCards[0]);
                    return undefined;
                });
            }));
        }
        const addFloaterOption = new SelectOption_1.SelectOption('Add 1 floater to this card', 'Add floater', () => {
            player.addResourceTo(this, { log: true });
            return undefined;
        });
        orOptions.options.push(addFloaterOption);
        return orOptions;
    }
    applyEffect(player, target) {
        player.removeResourceFrom(target, 2);
        LogHelper_1.LogHelper.logRemoveResource(player, this, 2, 'gain 1 titanium and 2 M€');
        player.addResource(Resources_1.Resources.TITANIUM, 1);
        player.addResource(Resources_1.Resources.MEGACREDITS, 2);
    }
}
exports.FloatingRefinery = FloatingRefinery;
//# sourceMappingURL=FloatingRefinery.js.map